'use client';
import { useEffect, useRef } from 'react';
/**
 * Returns a ref object that holds the value of the passed argument.
 * Useful for animations and other places where you want to track the value
 * of a variable without re-running a useEffect or useMemo.
 */
export function useBoundRef(value) {
    const ref = useRef(value);
    useEffect(() => {
        ref.current = value; //assign the value of ref to the argument
    }, [value]); //this code will run when the value of 'value' changes
    return ref;
}
//# sourceMappingURL=useBoundRef.js.map